import { useSelector } from 'react-redux';

export const useUserIsSignedIn = () => {
  return useSelector((state) => state?.user?.data?.userId);
};

export const useQuestionBank = () => {
  const user = useSelector((state) => state?.user?.data);
  return user?.questionBank;
};

export const useIsMainSubscribed = () => {
  const user = useSelector((state) => state?.user?.data);
  const isLoading = useSelector((state) => state?.user?.loading);

  if (isLoading || !user) {
    return false;
  }

  return (user.scopes || []).includes('scope_main_subscription');
};

export const useIsQbSubscribed = () => {
  const user = useSelector((state) => state?.user?.data);
  const isLoading = useSelector((state) => state?.user?.loading);

  if (isLoading || !user) {
    return false;
  }

  return (user.scopes || []).includes('scope_question_bank');
};

export const useIsSubscribedAny = () => {
  const main = useIsMainSubscribed();
  const qb = useIsQbSubscribed();
  return main || qb;
};

export const useIsSubscribedBoth = () => {
  const main = useIsMainSubscribed();
  const qb = useIsQbSubscribed();
  return main && qb;
};

export const useIsAdmin = () => {
  const user = useSelector((state) => state?.user?.data);
  return user?.role === 'Admin';
};

export const useUserIsEmail = (emails = []) => {
  const user = useSelector((state) => state?.user?.data);
  return emails.includes(user?.email);
};

export const useUserBookmarkIds = () => {
  const user = useSelector((state) => state?.user?.data);
  return user?.bookmarkedDocuments || [];
};
